/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Close_TicketInputs */

const en_settings_tickets_close_ticket = /** @type {(inputs: Settings_Tickets_Close_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Ticket`)
};

/**
* | output |
* | --- |
* | "Close Ticket" |
*
* @param {Settings_Tickets_Close_TicketInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_close_ticket = /** @type {((inputs?: Settings_Tickets_Close_TicketInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Close_TicketInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_close_ticket(inputs)
});
export { settings_tickets_close_ticket as "settings.tickets.close_ticket" }